type Declension = [string, string, string];

export const declOfNum = (
    value: number,
    titles: Declension
): string => {
    const n = Math.abs(value) % 100;
    const n1 = n % 10;

    if (n > 4 && n < 20) return titles[2];
    if (n1 === 1) return titles[0];
    if (n1 >= 2 && n1 <= 4) return titles[1];

    return titles[2];
};
